import { ButtonTagsComponent } from '@commons/o-button/button-tags/button-tags.component'
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
} from '@angular/core'
import { ChatDetailModel } from './chat-detail.model'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AuthService, ChatService, MatrixServices, RestServices, SharedServices } from '@app/services'
import { imageUrl } from '@helpers/common'
import { UploadFileComponent } from '@app/commons/upload-file/upload-file.component'
import { ChatModel } from '@models/chat.model'
import { APP_CONFIG, Config } from '@services/config.service'


@Component({
    selector: 'app-chat-detail',
    templateUrl: './chat-detail.component.html',
    styleUrls: ['./chat-detail.component.css'],
})
export class ChatDetailComponent implements OnInit {
    @Input() chatModel = new ChatDetailModel()
    @Input() type = 'message'
    @Input() tags: any[] = []
    @Output() _onShowImage: EventEmitter<any> = new EventEmitter()
    @Output() _onShowPdf: EventEmitter<any> = new EventEmitter()

    @ViewChild(ButtonTagsComponent) appTag: ButtonTagsComponent
    @ViewChildren(UploadFileComponent) appUploadFiles: QueryList<UploadFileComponent>

    INIT_PROP = 'init'
    isCreate: boolean
    hasChange = false
    note
    // next
    chatForm: FormGroup
    imageUrl = imageUrl
    en: any = {}
    showEN = true
    locale: any

    isValid = true
    isValidNote = true
    showDate
    statusReadonly = false
    communicationId: string
    private _isPatientCreate = false
    config: Config
    chatTags = []
    selectedCommunicationTags = []


    @Output() _closeAndScrollToTarget: EventEmitter<any> = new EventEmitter()

    @Input()
    public set isPatientCreate(value) {
        this.chatModel.isPatientCreate = value
        this._isPatientCreate = value
    }

    constructor(
        private formBuilder: FormBuilder,
        private authData: AuthService,
        private restApi: RestServices,
        public matrixServices: MatrixServices,
        private _sharedService: SharedServices,
        private chatService: ChatService,
        @Inject(APP_CONFIG) config: Config,
    ) {
        this.config = config
        this.createForm()
    }

    ngOnInit() {
        if (this.config) {
            this.chatTags = this.config.chatTags
        }
        this.locale = this.authData.getLang()
        this.changeLanguage()
    }

    createForm(type = 'message') {
        const fieldForms: any = {
            note: ['', Validators.nullValidator],
            // next: ['', Validators.nullValidator],
        }
        if (type === 'message') {
            fieldForms.note = ['', Validators.required]
        }
        this.changeLanguage()
        this.chatForm = this.formBuilder.group(fieldForms)
    }

    initForm(chatModel = new ChatDetailModel()) {
        this.createForm(chatModel.type)
        this.communicationId = chatModel._id
        this.type = chatModel.type
        this.note = chatModel.note
        // this.next = chatModel.next
        this.chatForm.get('note').setValue(this.note)
        // this.chatForm.get('next').setValue(this.next)
        this.chatModel = chatModel
        this.hasChange = false
        this.showDate = chatModel['updateTime']
        if (chatModel.clientId) {
            this.statusReadonly = true
            this.initChat(chatModel)
        } else {
            this.statusReadonly = false
        }
        this.markValid()
    }

    closeAndScrollToTarget(value) {
        this._closeAndScrollToTarget.emit(value)
    }

    clean() {
        console.log('clean chatDetail')
        setTimeout(() => {
            this.chatModel = null
            this.type = ''
        }, 100)

    }

    changeLanguage() {
        return (this.en = this.authData.showLang(this.showEN))
    }

    initChat(chatModel) {
        this.chatService.getChatInfo(chatModel._id).subscribe((chatData: ChatModel) => {
            if (chatData) {
                this.chatModel = chatData
                this.selectedCommunicationTags = this.initCommunicationTags(chatData.tags || [])
            }
        })
    }

    get getQuoteContent() {
        if (this.chatModel && this.chatModel.communication) {
            if (this.chatModel.communication.note || this.chatModel.communication.content) {
                return this.chatModel.communication.note || this.chatModel.communication.content
            } else {
                switch (this.chatModel.communication.type) {
                    case 'image':
                        return 'Image'
                    case 'pdf':
                        return 'PDF'
                    case 'video':
                        return 'Video'
                }
            }
        }
    }

    initCommunicationTags(tags = []) {
        return this.chatTags.filter(i => tags.includes(i._id))
    }

    validateForm() {
        console.debug('validateForm')
        this.chatModel.tags = this.appTag ? this.appTag.selectedTags : []
        this.chatModel.note = this.chatForm.value.note
        // this.chatModel.next = this.chatForm.value.next
        let validateResult = true
        this.isValidNote = true
        switch (this.type) {
            case 'message':
                if (!this.chatModel.note) {
                    validateResult = false
                    this.isValidNote = false
                }
                break
            case 'image':
                if (
                    this.chatModel.images.filter((i) => i !== this.INIT_PROP)
                        .length <= 0
                ) {
                    validateResult = false
                }
                break
            case 'video':
                if (
                    this.chatModel.video.filter((i) => i !== this.INIT_PROP)
                        .length <= 0
                ) {
                    validateResult = false
                }
                break
            case 'pdf':
                if (
                    this.chatModel.pdfs.filter((i) => i !== this.INIT_PROP)
                        .length <= 0
                ) {
                    validateResult = false
                }
                break
            default:
                validateResult = true
                break
        }
        this.isValid = validateResult
        return validateResult
    }

    uploadedFile(fileInfo, items, index, type = 'image') {
        this.markValid()
        let item = items[index]
        if (item == this.INIT_PROP) {
            item = {}
        }
        item.id = fileInfo.id
        if (type === 'image') {
            item.matrix = fileInfo.matrix
            // item.base64 = fileInfo.base64;
        } else if (type === 'video') {
            item.mime = fileInfo.mime
        } else if (type === 'pdf') {
            item.name = fileInfo.name
        }
        items[index] = item
        this.markChanged()
    }

    // @ts-ignore
    public get isPatientCreate(): boolean {
        return this._isPatientCreate
    }

    checkActiveTag(event) {
    }

    markChanged() {
        this.hasChange = true
    }

    formatVisitDate(value) {
    }

    // @ts-ignore
    get canEdit() {
        return this.chatModel ? this.chatModel.isPatientCreate : false
    }

    showBigImage(event, id, matrix) {
        event.stopPropagation()
        const arrImage = [id, 'showBigImageDetailCommunication', matrix]
        this._sharedService.emitChange(arrImage)
    }

    onShowImage(index) {
        this._onShowImage.emit(true)
    }

    removeItem(index, items: any[]) {
        items.splice(index, 1)
        if (items.length === 0) {
            items.push('init')
        }
        this.markChanged()
        this.cancelUpload(index)
    }

    addItem(items: any[]) {
        if (items[items.length - 1] == 'init') {
            return
        }

        items.push('init')
        this.markChanged()
    }

    private markValid() {
        this.isValid = true
        this.isValidNote = true
    }

    cancelUpload(index = null) {
        let fileUploadComponents: UploadFileComponent[] = this.appUploadFiles.toArray()
        if (index != null) {
            if (fileUploadComponents[index]) {
                fileUploadComponents = [fileUploadComponents[index]]
            }
        }

        for (let fileUploadComponent of fileUploadComponents) {
            fileUploadComponent.cancelUpload()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/app-component/chat-detail/chat-detail.component.ts